import { PillMenu } from '@/components/shared/PillMenu';
import { POI_SUMMARY_FIELDS } from '@/constants';
import { useAtom } from 'jotai';
import { useMemo } from 'react';
import * as state from '@/components/Analysis/state';

export const FieldSelector = ({
  variant = 'default',
  className,
  poiType,
}: {
  variant: 'default' | 'compact';
  className?: string;
  poiType?: string;
}) => {
  const [selectedFieldByType, setSelectedFieldByType] = useAtom(state.selectedFieldByType);

  const handleChange = (label: string) => {
    const selectedItem = POI_SUMMARY_FIELDS.find((field) => field.label === label);
    if (!selectedItem) return;
    setSelectedFieldByType((prev) => ({
      ...prev,
      [poiType || 'Other']: selectedItem,
    }));
  };

  const selectedField = useMemo(
    () => selectedFieldByType[poiType || 'Other'],
    [selectedFieldByType, poiType]
  );

  if (!selectedField) return <></>;

  return (
    <PillMenu
      key={`field-selector`}
      size={variant === 'default' ? 'medium' : 'small'}
      options={POI_SUMMARY_FIELDS.map((field) => field.label)}
      initialValue="Field"
      label={selectedField.label ?? ''}
      getPillStatus={() => 'linked'}
      loading={false}
      loadingLabel=""
      onChange={handleChange}
      className={className}
    />
  );
};
